<!--
=========================================================
* Vue Argon Dashboard 2 - v4.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { modulesName } from "@/store";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

const store = useStore();

const appState = computed(() => store.state[`${modulesName.appModuleName}`]);

const isNavFixed = computed(() => appState.value.isNavFixed);
const darkMode = computed(() => appState.value.darkMode);
const isAbsolute = computed(() => appState.value.isAbsolute);
const showSidenav = computed(() => appState.value.showSidenav);
const layout = computed(() => appState.value.layout);
const showNavbar = computed(() => appState.value.showNavbar);
const showFooter = computed(() => appState.value.showFooter);
const showConfig = computed(() => appState.value.showConfig);
const hideConfigButton = computed(() => appState.value.hideConfigButton);
const toggleConfigurator = () => store.commit("toggleConfigurator");

const navClasses = computed(() => {
  return {
    "position-sticky bg-white left-auto top-2 z-index-sticky":
      isNavFixed.value && !darkMode.value,
    "position-sticky bg-default left-auto top-2 z-index-sticky":
      isNavFixed.value && darkMode.value,
    "position-absolute px-4 mx-0 w-100 z-index-2": isAbsolute.value,
    "px-0 mx-4": !isAbsolute.value,
  };
});
</script>
<template>
  <link
    rel="stylesheet"
    href="https://unpkg.com/vue-multiselect/dist/vue-multiselect.min.css"
  />
  <loading
    v-model:active="appState.isLoading"
    :is-full-page="true"
    color="#008240"
  />

  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>

  <sidenav v-if="showSidenav" />

  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
  >
    <!-- nav -->

    <navbar :class="[navClasses]" v-if="showNavbar" />

    <router-view />

    <app-footer v-show="showFooter" />

    <configurator
      :toggle="toggleConfigurator"
      :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
    />
  </main>
</template>
